/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListPartCommandsHasVariables = () => {
    const { t } = useTranslation();

    document.title = "Ligações de variáveis e parts de comandos";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [parts, setParts] = useState([]);
    const [variables, setVariables] = useState([]);

    const partCommandField = useRef();
    const variableFiled = useRef();

    const partCommandValue = useRef();
    const variableValue = useRef();

    useEffect(() => {
        async function getAllPartCommands(){
            let currentList = await Services.current.getPartCommandsHasVariables();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getPartCommand(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }

        async function getVariables(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setVariables(currentItem);
        }

        getAllPartCommands();
        getPartCommand();
        getVariables();
    },[])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(partCommandValue.current) && isValidField(variableValue.current)){

            let form = new FormData();
            if(partCommandValue.current){form.append('part_command', partCommandValue.current)}
            if(variableValue.current){form.append('variable', variableValue.current)}

    
            await Services.current.SavePartCommandHasVariable(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Ligações de variáveis e parts de comandos
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Ligações" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ Criar nova ligação"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>part command</TitleText>
                        <TitleText>variável</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommandsHasVariables/${item.id}`}>
                                <ListText>{item.part_command_name}</ListText>
                                <ListText>{item.variable_name}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={t("administrative.partCommands.add")} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"part Command"} aling="flex-start"/>
                        <InputSelect
                            key={'part_command'}
                            name={'part_command'}
                            id={'part_command'}
                            placeholder={"Part Command"}
                            invalidMessage = {"Part Command inválido!"}
                            options={parts}
                            innerRef={partCommandField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => partCommandValue.current = value}>
                        </InputSelect>                      
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"variável"} aling="flex-start"/>
                        <InputSelect
                            key={'variable'}
                            name={'variable'}
                            id={'variable'}
                            placeholder={"Variável"}
                            invalidMessage = {"Variável inválida!"}
                            options={variables}
                            innerRef={variableFiled}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => variableValue.current = value}>
                        </InputSelect>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartCommandsHasVariables;